import React from "react";
import S from "./styled";
import { ITextProps } from "./type";

const Text: React.FC<ITextProps> = ({
	color,
	children,
	height,
	onClick,
	radius,
	width,
	className,
	text,
	size,
	disabled,
	level,
	weight,
	style,
	...props
}) => {
	return (
		<S.Text
			onClick={onClick}
			text={text}
			className={`${className} inline-flex items-center`}
			size={size}
			disabled={disabled}
			weight={weight}
			level={level}
			style={style}
			color={color}
			{...props}
		>
			{children}
		</S.Text>
	);
};

export default Text;
